"use client";

// Fiche produit : la remise du compte pro qui s'appliquera toute seule au panier pour
// cette destination (GT-261007-HVGQ). Rien pour un visiteur, un compte non pro, ou une
// destination hors de ses remises. `total` (EUR) : montre aussi le prix apres remise.
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import ConvertedPrice from "@/app/[lang]/[currency]/(chrome)/checkout/ConvertedPrice";
import { accountDiscountForCity, useAccountDiscounts } from "@/app/lib/useAccountDiscounts";

interface Props {
  cityId: number | null | undefined;
  total?: number;
  compact?: boolean;
}

const AccountDiscountNotice: FC<Props> = ({ cityId, total, compact = false }) => {
  const { t } = useTranslation("guydeez");
  const discounts = useAccountDiscounts();
  const discount = accountDiscountForCity(discounts, cityId == null ? null : Number(cityId));
  if (!discount) return null;

  const value = discount.type === "percentage" ? `−${discount.value} %` : `−${discount.value} €`;
  const after =
    total && total > 0
      ? discount.type === "percentage"
        ? total * (1 - discount.value / 100)
        : Math.max(0, total - discount.value)
      : null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 8,
        padding: compact ? "8px 10px" : "10px 14px",
        margin: compact ? "0 0 12px" : "0 0 16px",
        borderRadius: 12,
        background: "#F3FAF5",
        border: "1px solid var(--g-green-soft, #CDEBD6)",
        color: "var(--g-green-ink, #1F7A45)",
        fontSize: 13,
        lineHeight: 1.45,
      }}
    >
      <span
        style={{
          flex: "0 0 auto",
          padding: "1px 8px",
          borderRadius: 999,
          background: "var(--g-green-ada, #2E7D4F)",
          color: "#fff",
          fontWeight: 800,
          fontSize: 12,
        }}
      >
        {value}
      </span>
      <span>
        {t("account_discount_product", {
          defaultValue: "Votre remise professionnelle s’applique automatiquement au panier, sans code.",
        })}
        {after !== null && (
          <>
            {" "}
            <strong style={{ whiteSpace: "nowrap" }}>
              {t("account_discount_product_total", { defaultValue: "Total remisé :" })}{" "}
              <ConvertedPrice price={after} />
            </strong>
          </>
        )}
      </span>
    </div>
  );
};

export default AccountDiscountNotice;
